import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ExpressionCondition } from '@/models/audiences';
import { ActionRule, MembershipRule, PropertyRule } from '.';
import { PropertyOperations } from '@/services/endpoints/audiences';

interface IRuleRenderProps {
  expression?: ExpressionCondition;
  propertyOperations: PropertyOperations;
}

export const RuleRender: FunctionComponent<IRuleRenderProps> = ({ expression, propertyOperations }) => {
  const { t } = useTranslation('ALL');

  switch (expression?.type) {
    case 'MEMBERSHIP':
      return <MembershipRule expression={expression} />;
    case 'ACTION':
      return <ActionRule expression={expression} />;
    case 'PROPERTY':
      return <PropertyRule expression={expression} propertyOperations={propertyOperations} />;
    default:
      return (
        <div className='flex w-full'>
          <p>{t('expressionOfType', { type: expression?.type })}</p>
        </div>
      );
  }
};
